<template>
  <div id="export">
    <main-layout>
      <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
        <v-tab ripple :key="'chat-log'" :href="'#chat-log'">{{ $t('chat_log') }}</v-tab>
      </v-tabs>
      <template v-if="currentView == 'chat-log'">
        <v-container>
          <v-layout wrap>
            <v-flex xs5 px-2 class="form-control" :class="{ 'has-error': errors.has('formDate') }">
              <span>{{ $t('from') }}:</span>
              <v-menu
                ref="showFromDate"
                v-model="showFromDate"
                :close-on-content-click="false"
                full-width
                max-width="290px"
                color="primary"
              >
                <template v-slot:activator="{ on }">
                  <input
                    type="text"
                    class="form-control browser-default"
                    :placeholder="$t('Date')"
                    readonly
                    v-model="fromDate"
                    v-on="on"
                    clearable
                  />
                </template>
                <v-date-picker
                  color="primary"
                  v-model="fromDate"
                  @input="showFromDate = false"
                  :max="maxDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs5 px-2 class="form-control" :class="{ 'has-error': errors.has('toDate') }">
              <span>{{ $t('to') }}:</span>
              <v-menu
                ref="showToDate"
                v-model="showToDate"
                :close-on-content-click="false"
                full-width
                max-width="290px"
                color="primary"
              >
                <template v-slot:activator="{ on }">
                  <input
                    type="text"
                    class="form-control browser-default"
                    :placeholder="$t('Date')"
                    readonly
                    v-model="toDate"
                    v-on="on"
                    clearable
                  />
                </template>
                <v-date-picker
                  color="primary"
                  v-model="toDate"
                  :max="maxDate"
                  @input="showToDate = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs2 class="mb-1 ml-0" style="display: flex; align-items: flex-end">
              <v-btn
                color="primary"
                style="width: 100%"
                class="ml-0"
                @click="handleSearchCountChatLog"
                >{{ $t('Search') }}</v-btn
              >
            </v-flex>
          </v-layout>
          <div v-if="countChatLog || countChatLog == 0" class="w-100 mt-4 fade-in">
            <v-layout
              row
              wrap
              class="px-2 py-3"
              style="border: 3px solid #c4c4c4; border-radius: 5px"
              justify-end
            >
              <div class="flex-all-center my-2" style="width: 100%; font-size: 18px">
                จำนวนรายการทั้งหมด {{ numberWithCommas(countChatLog) }} รายการ
              </div>
              <div>
                <v-btn color="primary" @click="handleDownloadChatLog">{{ $t('export') }}</v-btn>
                <v-btn color="primary" @click="handleManualPostChatLog"
                  >ส่งออกข้อมูล Log ไปยัง กบข.</v-btn
                >
              </div>
            </v-layout>
          </div>
        </v-container>
      </template>
    </main-layout>
  </div>
</template>

<script>
import moment from 'moment'
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  data: function () {
    return {
      currentView: 'chat-log',
      maxDate: moment().format('YYYY-MM-DD'),
      fromDate: moment().format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      showFromDate: false,
      showToDate: false,
      countChatLog: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    numberWithCommas(x) {
      x = x.toString()
      var pattern = /(-?\d+)(\d{3})/
      while (pattern.test(x)) x = x.replace(pattern, '$1,$2')
      return x
    },
    async handleSearchCountChatLog() {
      const vm = this
      vm.$store.dispatch('loading')
      try {
        const response = await api.countChatlog({
          startDate: vm.fromDate,
          endDate: vm.toDate,
          pageId: vm.selectedBot.pageid
        })
        if (response && response.data && response.data.data && response.data.data.count) {
          vm.countChatLog = response.data.data.count
        } else if (response.data.data.count == 0) {
          vm.countChatLog = null
          vm.$swal.fire({
            text: 'ไม่พบข้อมูล'
          })
        } else {
          vm.countChatLog = null
        }
      } catch (error) {
        vm.countChatLog = null
        console.error(error)
        vm.$swal.fire({
          type: 'error',
          text: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง'
        })
      } finally {
        vm.$store.dispatch('loading')
      }
    },

    async handleManualPostChatLog() {
      const vm = this
      vm.$store.dispatch('loading')
      try {
        await api.manualPostChatLog({
          startDate: vm.fromDate,
          endDate: vm.toDate,
          pageId: vm.selectedBot.pageid
        })
        vm.$store.dispatch('loading')
        vm.$swal.fire({
          type: 'success',
          text: 'ส่งข้อมูลสำเร็จ'
        })
      } catch (error) {
        console.error(error)
        vm.$store.dispatch('loading')
        vm.$swal.fire({
          type: 'error',
          text: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง'
        })
      }
    },
    async handleDownloadChatLog() {
      const vm = this
      vm.$store.dispatch('loading')
      try {
        const response = await api.exportChatLog({
          startDate: vm.fromDate,
          endDate: vm.toDate,
          pageId: vm.selectedBot.pageid
        })

        if (response.data) {
          const fileName = `CHATLOG_REPORT_${vm.fromDate}_${vm.toDate}.csv`
          const temp = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = temp
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
        }

        vm.$store.dispatch('loading')
      } catch (error) {
        console.error(error)
        vm.$store.dispatch('loading')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/Export/Export.vue